import { render } from "./TheNavbar.vue?vue&type=template&id=ebb5f2a4"
import script from "./TheNavbar.vue?vue&type=script&lang=js"
export * from "./TheNavbar.vue?vue&type=script&lang=js"
script.render = render

export default script